module.exports = __webpack_public_path__ + "img/5bbb5b1.jpg";